// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input_time_selector {
  width: 156px;
  font-family: "Nunito Sans", sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/components/AppointmentsComponents/AppointmentsMainTimeSelector/AppointmentsMainTimeSelector.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,sCAAA;AACJ","sourcesContent":[".input_time_selector {\r\n    width: 156px;\r\n    font-family: \"Nunito Sans\", sans-serif;\r\n    // background-color: #eeecec;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
